import React, { Component } from "react";
import { Link } from "react-router-dom";
//import $ from "jquery";
import {
  FormattedMessage,
  FormattedHTMLMessage,
  IntlProvider,
} from "react-intl";
import Carousel from "react-bootstrap/Carousel";
import Footer from "./includes/Footer";
import Register from "./includes/Register";
import { history } from "../helper/History";
import $ from "jquery";
//import { FormattedHTMLMessage } from "react-intl";

class Youconsultant extends Component {
  constructor(props) {
    super(props);
    this.state = {
      dis: "",
    };
    window.scrollTo(0, 0); // scroll page to top
  }
  // componentDidMount(){
  //   if (this.props.isSignedIn) {

  //     this.setState({dis:"none"});
  //   }
  //   console.log(this.state.dis);
  // }

  showRegister(e) {
    var userType = localStorage.getItem("role");
    if (!userType) {
      history.push("/register");
      // console.log('in '+e);
      // $("#loginModal").modal("show");
      // $("#register-form").delay(100).fadeIn(100);
      // $("#login-form").fadeOut(100);
      // $("#login-form-link").removeClass("active");
      // console.log('Inside Header '+e);
      // if(e === '#register-form-link'){
      //   $('.modal-title').text('SIGNUP');
      //   $(e).addClass("active");
      // }else{
      //   $(e.target).addClass("active");
      // }
    }
  }

  sendparam() {
    localStorage.setItem("classic", "classic");
  }
  showRegister2(e) {
    console.log("in " + e);
    $("#loginModal").modal("show");
    $("#register-form").delay(100).fadeIn(100);
    $("#login-form").fadeOut(100);
    $("#login-form-link").removeClass("active");
    // console.log("Inside Header " + e);
    if (e === "#register-form-link") {
      $(".modal-title").text("SIGNUP");
      $(e).addClass("active");
    } else {
      $(e.target).addClass("active");
    }
  }

  setSkillsNavigation() {
    const userRole = localStorage.getItem("userRole");

    if (userRole === "Hr") {
      localStorage.setItem("navigation", "skills");
    } else if (userRole === "Enterprise") {
      localStorage.setItem("navigation", "enterprise");
    } else if (userRole === "User") {
      localStorage.setItem("navigation", "individual");
    } else {
      localStorage.setItem("navigation", "skills");
    }
  }

  render() {
      const userRole = localStorage.getItem("userRole");
    return (
      <React.Fragment>
        <section id="wrapper" className="icon-boxed1 teaser-box consultant-hero-section">
          {userRole && (
           <Link to="/youareaconsultant" onClick={this.setSkillsNavigation.bind(this)}>
              <div
                className="white-btns-hr consultant-btn "
                style={{
                  backgroundColor: "#003366",
                  color: "white",
                  width: "370px",
                  marginTop: "5%",
                  borderRadius: "5px",
                  height: "65px"
                }}
              >
                <div>
                  <FormattedHTMLMessage
                      id={userRole === "User" ? "sub.menue" : userRole === "Hr" ? "sub.menue1" : userRole === "Enterprise" ? "sub.menue2" : "sub.menue"}
                    defaultMessage="<p className='pb-1'> €350 VAT included <span className='small'>instead of <del>450 €</del></span></p>"
                  />
                </div>
              </div>
            </Link>
          )}

          <div className="container consultant-content-area">
            <div className="consultant-cards-wrap">
              <Link to="/hr" style={{ textDecoration: "none" }} onClick={this.setSkillsNavigation.bind(this)}>
                <div className="consultant-card">
                  <div className="consultant-card-icon">◎</div>
                  <h3 className="consultant-card-title">
                    <FormattedHTMLMessage
                      id="you.company.title3"
                      defaultMessage="starter"
                    />
                  </h3>
                  <div className="consultant-card-divider"></div>
                  <div className="consultant-card-content" style={{marginLeft:"62%"}}>
                    <FormattedHTMLMessage
                      id="youareaconsultant.card1.text2"
                      defaultMessage="12 months"
                    />
                  </div>
                  <button className="consultant-discover-btn">
                    <FormattedHTMLMessage
                      id="Discover"
                      defaultMessage="Subscribe"
                    />
                  </button>
                </div>
              </Link>

              <Link to="/individual" style={{ textDecoration: "none" }}>
                <div className="consultant-card">
                  <div className="consultant-card-icon">👥</div>
                  <h3 className="consultant-card-title">
                    <FormattedHTMLMessage
                      id="you.consultant.title2"
                      defaultMessage="Classic"
                    />
                  </h3>
                  <div className="consultant-card-divider"></div>
                  <div className="consultant-card-content" style={{marginLeft:"30%"}}>
                    <FormattedHTMLMessage
                      id="youareaconsultant.card2.text1"
                      defaultMessage="€49.90"
                    />
                    <FormattedHTMLMessage
                      id="youareaconsultant.card2.text2"
                      defaultMessage="€49.90"
                    />
                  </div>
                  <button
                    className="consultant-discover-btn"
                    onClick={this.sendparam()}
                  >
                    <FormattedHTMLMessage
                      id="Discover"
                      defaultMessage="Subscribe"
                    />
                  </button>
                </div>
              </Link>

              <Link to="/partner" style={{ textDecoration: "none" }} onClick={this.setSkillsNavigation.bind(this)}>
                <div className="consultant-card">
                 <div className="consultant-card-icon consultant-card-icon-with-star">
                  <span className="consultant-user-circle" style={{marginLeft: "46%"}}>👤</span>
                  <span className="consultant-star-icon">★</span>
                </div>
                   
                  <h3 className="consultant-card-title">
                    <FormattedHTMLMessage
                      id="you.consultant.title3"
                      defaultMessage="Classic"
                    />
                  </h3>
                  <div className="consultant-card-divider"></div>
                  <div className="consultant-card-content" style={{marginLeft:"45%"}}>
                    <FormattedHTMLMessage
                      id="youareaconsultant.card3.text1"
                      defaultMessage="€49.90"
                    />
                    <FormattedHTMLMessage
                      id="youareaconsultant.card3.text2"
                      defaultMessage="€49.90"
                    />
                  </div>
                  <button className="consultant-discover-btn">
                    <FormattedHTMLMessage
                      id="Discover"
                      defaultMessage="Subscribe"
                    />
                  </button>
                </div>
              </Link>
            </div>

            <div className="consultant-bottom-cta">
              <span className="consultant-bottom-cta-icon">📈</span>
              <span>
                <FormattedHTMLMessage
                  id="youareaconsultant.bottom.text1"
                  defaultMessage="Gain independence and DOUBLE your income!"
                />
              </span>
            </div>
          </div>
        </section>
      </React.Fragment>
    );
  }
}
export default Youconsultant;
